import { NgModule, inject } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ApikeysComponent } from './apikeys/apikeys/apikeys.component';
import { DispositivosLorawanComponent } from './dispositivos-lorawan/dispositivos-lorawan/dispositivos-lorawan.component';
import { CrearEditarDispositivoLorawanComponent } from './dispositivos-lorawan/crear-editar-dispositivo-lorawan/crear-editar-dispositivo-lorawan.component';
import { DetallesDispositivoLorawanComponent } from './dispositivos-lorawan/detalles-dispositivo-lorawan/detalles-dispositivo-lorawan.component';
import { CrearEditarApikeyComponent } from './apikeys/crear-editar-apikey/crear-editar-apikey.component';
import { CrearEditarClienteComponent } from './clientes/crear-editar-cliente/crear-editar-cliente.component';
import { CrearEditarTrackerComponent } from './trackers/crear-editar-tracker/crear-editar-tracker.component';
import { ListadoUsuariosComponent } from './usuarios/listado-usuarios/listado-usuarios.component';
import { ConfigurarUsuarioComponent } from './usuarios/configurar-usuario/configurar-usuario.component';
import { ListadoTrackersComponent } from './trackers/trackers/trackers.component';
import { ListadoSimsComponent } from './sims/listado-sims/listado-sims.component';
import { DetallesSimComponent } from './sims/detalles-sim/detalles-sim.component';
import { SimsService } from '../../../auxiliares/servicios/http/sims.service';
import { DashcamsService } from '../../../auxiliares/servicios/http/dashcams.service';
import { ListadoDashcamsComponent } from './dashcams/listado-dashcams/listado-dashcams.component';
import { DetallesDashcamComponent } from './dashcams/detalles-dashcam/detalles-dashcam.component';
import { DetallesTrackersComponent } from './trackers/detalles-tracker/detalles-trackers.component';
import { ServiciosComponent } from './servicios-contratados/servicios/servicios.component';
import { CrearEditarServiciosComponent } from './servicios-contratados/crear-editar-servicios/crear-editar-servicios.component';
import { DetallesClienteComponent } from './clientes/clientes/detalles-cliente/detalles-cliente.component';
import { ListadoClientesComponent } from './clientes/clientes/clientes-listado/clientes-listado.component';
import { ClientesGuard } from './clientes/clientes.guard';
import { TecnicosComponent } from './tecnicos/tecnicos/tecnicos.component';
// Eventos Técnicos Genéricos
import { MenuTecnicoGenericoComponent } from './eventos-tecnicos-genericos/listado-eventos-tecnicos/menu-tecnico.component';
import { LogsDespachosComponent } from './logs-despachos/logs-despachos-listado/logs-despachos.component';
import { ListadoDocumentosComponent } from '../../standalone/documentos/listado-documentos/listado-documentos.component';
import { ListadoConfigReenviosComponent } from './config-reenvios/listado-config-reenvios/listado-config-reenvios.component';
import { ListadoLogReenviosComponent } from './log-reenvios/listado-log-reenvios/listado-log-reenvios.component';
import { ActividadUsuariosComponent } from './actividad-usuarios/actividad-usuarios.component';
import { CrearEditarConfigReenviosComponent } from './config-reenvios/crear-editar-config-reenvio/crear-editar-config-reenvio.component';
import { ListadoEstadoEntidadsComponent } from './estado-entidad/listado/listado.component';
import { ListadoBotonBLEComponent } from './boton-ble/listado-boton-ble/listado-boton-ble.component';
import { DetallesBotonBLEComponent } from './boton-ble/detalles-boton-ble/detalles-boton-ble.component';
import { ListadoGatewaysComponent } from './gateways/listado-gateways/listado-gateways.component';
import { CrearEditarGatewayComponent } from './gateways/crear-editar-gateway/crear-editar-gateway.component';
import { DetallesGatewayComponent } from './gateways/detalles/detalles.component';
import { ListadoRolesComponent } from './roles/listado-roles/listado-roles.component';
import { CrearEditarRolsComponent } from './roles/crear-editar-rol/crear-editar-rol.component';
import { ListadoAuditoriasComponent } from './auditorias/listado-auditorias/listado-auditorias.component';
import { ListadoCategoriasEventosTecnicosComponent } from './categorias-eventos-tecnicos/categorias-eventos-tecnicos.component';
import { ListadoTemasComponent } from './temas/listado-temas/listado-temas.component';
import { CrearEditarTemaComponent } from './temas/crear-editar-tema/crear-editar-tema.component';
import { EstadisticasUsoComponent } from './estadisticas-uso/estadisticas-uso.component';
import { adminRootGuard } from '../../../auxiliares/servicios/admin-root.guard';
import { BusquedaTelefonoComponent } from './busqueda-telefono/busqueda-telefono.component';
import { ExportacionesComponent } from './exportaciones/exportaciones.component';
// Eventos (movidos desde Configuración a Administración)
import { ListadoCategoriasEventosComponent } from '../configuracion/categorias-eventos/listado-categorias-eventos/listado-categorias-eventos.component';
import { ListadoTiposEventosComponent } from '../configuracion/tipos-eventos/listado-tipos-eventos.component';
import { ListadoConfigEventoUsuarioComponent } from '../../standalone/config-evento-usuario/listado-config-evento-usuario/listado-config-evento-usuario.component';
import { CrearEditarConfigEventoUsuarioDialogComponent } from '../../standalone/config-evento-usuario/crear-editar-config-evento-usuario-dialog/crear-editar-config-evento-usuario-dialog.component';

const routes: Routes = [
  { path: '', redirectTo: 'usuarios', pathMatch: 'full' },
  // Buscar por teléfono (contactos, alarmas, trackers, etc.)
  {
    path: 'buscar-telefono',
    title: 'Buscar por teléfono',
    component: BusquedaTelefonoComponent,
  },
  // Permisos (alta/edición vía diálogo desde el listado; no por ruta)
  { path: 'usuarios', title: 'Permisos', component: ListadoUsuariosComponent },
  // Configurar el propio usuario (datos personales del usuario logueado)
  {
    path: 'configurar-usuario',
    title: 'Configurar usuario',
    component: ConfigurarUsuarioComponent,
  },
  // Técnicos (alta/edición vía diálogo desde el listado)
  { path: 'tecnicos', title: 'Técnicos', component: TecnicosComponent },
  // Eventos Técnicos Genéricos
  {
    path: 'eventosTecnicos',
    title: 'Servicios técnicos',
    component: MenuTecnicoGenericoComponent,
  },

  //Categorías Eventos Técnicos
  {
    path: 'categoriasServicioTecnico',
    title: 'Categorías de servicio técnico',
    component: ListadoCategoriasEventosTecnicosComponent,
  },
  {
    path: 'clientes',
    title: 'Clientes',
    component: ListadoClientesComponent,
    canActivate: [ClientesGuard],
  },
  {
    path: 'clientes/crear',
    title: 'Nuevo cliente',
    component: CrearEditarClienteComponent,
    canActivate: [ClientesGuard],
  },
  {
    path: 'clientes/editar/:id',
    title: 'Editar cliente',
    component: CrearEditarClienteComponent,
    canActivate: [ClientesGuard],
  },
  {
    path: 'clientes/detalles/:id',
    title: 'Cliente',
    component: DetallesClienteComponent,
    canActivate: [ClientesGuard],
  },
  // Apikeys
  { path: 'apikeys', title: 'API keys', component: ApikeysComponent },
  {
    path: 'apikeys/crear',
    title: 'Nueva API key',
    component: CrearEditarApikeyComponent,
    canActivate: [],
  },
  {
    path: 'apikeys/editar/:id',
    title: 'Editar API key',
    component: CrearEditarApikeyComponent,
    canActivate: [],
  },

  //Botones BLE
  {
    path: 'botones-ble',
    title: 'Botones BLE',
    component: ListadoBotonBLEComponent,
    canActivate: [],
  },
  {
    path: 'botones-ble/detalles/:id',
    title: 'Botón BLE',
    component: DetallesBotonBLEComponent,
    canActivate: [],
  },
  //Dispositivos Lorawan
  {
    path: 'dispositivoslorawan',
    title: 'Dispositivos LoRaWAN',
    component: DispositivosLorawanComponent,
  },
  {
    path: 'dispositivoslorawan/crear',
    title: 'Nuevo dispositivo LoRaWAN',
    component: CrearEditarDispositivoLorawanComponent,
    canActivate: [],
  },
  {
    path: 'dispositivoslorawan/editar/:id',
    title: 'Editar dispositivo LoRaWAN',
    component: CrearEditarDispositivoLorawanComponent,
    canActivate: [],
  },
  {
    path: 'dispositivoslorawan/detalles/:id',
    title: 'Dispositivo LoRaWAN',
    component: DetallesDispositivoLorawanComponent,
    canActivate: [],
  },

  //Gateways
  { path: 'gateways', title: 'Gateways', component: ListadoGatewaysComponent },
  {
    path: 'gateways/detalles/:id',
    title: 'Gateway',
    component: DetallesGatewayComponent,
    canActivate: [],
  },
  {
    path: 'gateways/crear',
    title: 'Nuevo gateway',
    component: CrearEditarGatewayComponent,
    canActivate: [],
  },
  {
    path: 'gateways/editar/:id',
    title: 'Editar gateway',
    component: CrearEditarGatewayComponent,
    canActivate: [],
  },

  // Trackers
  {
    path: 'trackers',
    title: 'Trackers',
    component: ListadoTrackersComponent,
    canActivate: [],
  },
  {
    path: 'trackers/crear',
    title: 'Nuevo tracker',
    component: CrearEditarTrackerComponent,
    canActivate: [],
  },
  {
    path: 'trackers/editar/:id',
    title: 'Editar tracker',
    component: CrearEditarTrackerComponent,
    canActivate: [],
  },
  {
    path: 'trackers/detallesTracker/:id',
    title: 'Tracker',
    component: DetallesTrackersComponent,
    canActivate: [],
  },
  // SIMs (alta/edición vía diálogo desde el listado o el detalle)
  {
    path: 'sims',
    title: 'SIMs',
    component: ListadoSimsComponent,
    canActivate: [() => inject(SimsService).puedeVer()],
  },
  {
    path: 'sims/:id',
    title: 'SIM',
    component: DetallesSimComponent,
    canActivate: [() => inject(SimsService).puedeVer()],
  },
  // Dashcams (alta/edición vía diálogo desde el listado o el detalle)
  {
    path: 'dashcams',
    title: 'Dashcams',
    component: ListadoDashcamsComponent,
    canActivate: [() => inject(DashcamsService).puedeVer()],
  },
  {
    path: 'dashcams/detalles/:id',
    title: 'Dashcam',
    component: DetallesDashcamComponent,
    canActivate: [() => inject(DashcamsService).puedeVer()],
  },
  // Servicios Contratados
  {
    path: 'servicios',
    title: 'Servicios ofrecidos',
    component: ServiciosComponent,
    canActivate: [],
  },
  {
    path: 'servicios/crear',
    title: 'Nuevo servicio',
    component: CrearEditarServiciosComponent,
    canActivate: [],
  },
  {
    path: 'servicios/editar/:id',
    title: 'Editar servicio',
    component: CrearEditarServiciosComponent,
  },
  // Documentos
  {
    path: 'documentos/:id/:tipo/:categoria',
    title: 'Documentos',
    component: ListadoDocumentosComponent,
  },
  // Logs Despachos
  {
    path: 'logsdespachos',
    title: 'Logs de despachos',
    component: LogsDespachosComponent,
    canActivate: [],
  },
  // Config Reenvios
  {
    path: 'config-reenvios',
    title: 'Configuración de reenvíos',
    component: ListadoConfigReenviosComponent,
    canActivate: [],
  },
  {
    path: 'config-reenvios/crear',
    title: 'Nuevo reenvío',
    component: CrearEditarConfigReenviosComponent,
    canActivate: [],
  },
  {
    path: 'config-reenvios/editar/:id',
    title: 'Editar reenvío',
    component: CrearEditarConfigReenviosComponent,
    canActivate: [],
  },

  // Log Reenvios
  {
    path: 'log-reenvios',
    title: 'Log de reenvíos',
    component: ListadoLogReenviosComponent,
    canActivate: [],
  },
  // Estados Enditad
  {
    path: 'estados-entidad',
    title: 'Estados de cuenta',
    component: ListadoEstadoEntidadsComponent,
    canActivate: [],
  },
  // Auditorías
  {
    path: 'auditorias',
    title: 'Auditorías',
    component: ListadoAuditoriasComponent,
  },
  // Temas (admin root)
  {
    path: 'temas',
    title: 'Temas',
    component: ListadoTemasComponent,
    canActivate: [adminRootGuard],
  },
  {
    path: 'temas/crear',
    title: 'Nuevo tema',
    component: CrearEditarTemaComponent,
    canActivate: [adminRootGuard],
  },
  {
    path: 'temas/editar/:id',
    title: 'Editar tema',
    component: CrearEditarTemaComponent,
    canActivate: [adminRootGuard],
  },
  // Estadísticas de uso (admin root)
  {
    path: 'estadisticas-uso',
    title: 'Estadísticas de uso',
    component: EstadisticasUsoComponent,
    canActivate: [adminRootGuard],
  },
  // Actividad de usuarios: contenedor con dos tabs (inactividad + exceso),
  // cada uno gateado por su acción de rol en el propio contenedor/backend.
  {
    path: 'actividad-usuarios',
    title: 'Actividad de usuarios',
    component: ActividadUsuariosComponent,
    canActivate: [],
  },
  // Exportaciones
  {
    path: 'exportaciones',
    title: 'Exportaciones',
    component: ExportacionesComponent,
  },
  // Roles
  { path: 'roles', title: 'Roles', component: ListadoRolesComponent },
  {
    path: 'roles/crear',
    title: 'Nuevo rol',
    component: CrearEditarRolsComponent,
    canActivate: [],
  },
  {
    path: 'roles/editar/:id',
    title: 'Editar rol',
    component: CrearEditarRolsComponent,
    canActivate: [],
  },

  // Eventos
  {
    path: 'categoriasEventos',
    title: 'Categorías de eventos',
    component: ListadoCategoriasEventosComponent,
    canActivate: [],
  },
  {
    path: 'tiposEventos',
    title: 'Tipos de eventos',
    component: ListadoTiposEventosComponent,
    canActivate: [],
  },
  {
    path: 'config-evento-usuario',
    title: 'Eventos personalizados',
    component: ListadoConfigEventoUsuarioComponent,
    canActivate: [],
  },
  {
    path: 'config-evento-usuario/crear',
    title: 'Nuevo evento personalizado',
    component: CrearEditarConfigEventoUsuarioDialogComponent,
    canActivate: [],
  },
  {
    path: 'config-evento-usuario/editar/:id',
    title: 'Editar evento personalizado',
    component: CrearEditarConfigEventoUsuarioDialogComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdministracionRoutingModule {}
